import type { CrowdexUIMessage } from '@crowdex/agent-contracts';

/** The plain-text projection of a message used for copy/edit actions: its text parts. */
export function messageText(message: CrowdexUIMessage): string {
  return message.parts
    .filter((part) => part.type === 'text')
    .map((part) => part.text)
    .join('\n\n')
    .trim();
}
